import { render, staticRenderFns } from "./PlusButton.vue?vue&type=template&id=8ceaf4bc&"
import script from "./PlusButton.vue?vue&type=script&lang=js&"
export * from "./PlusButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ceaf4bc')) {
      api.createRecord('8ceaf4bc', component.options)
    } else {
      api.reload('8ceaf4bc', component.options)
    }
    module.hot.accept("./PlusButton.vue?vue&type=template&id=8ceaf4bc&", function () {
      api.rerender('8ceaf4bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/PlusButton.vue"
export default component.exports